// @ts-nocheck
import { createContext, useContext } from 'react'

export interface CaseData {
  id: string
  name: string
  slug?: string
  description: string | null
  status: 'draft' | 'active' | 'closed' | 'archived'
  /** Changes the wording of the overview; absent on an older server. */
  kind?: 'incident' | 'theme'
  created_at: string
  updated_at: string
  created_by?: string | null
  document_count: number
  entity_count: number
  relationship_count: number
  workflows: Array<{
    id: string
    workflow_id: string
    workflow_type: string | null
    file_name: string | null
    status: string
    created_at: string
  }>
}

export interface CaseContextValue {
  caseId: string
  caseData: CaseData
  refetchCase: () => void
}

const CaseContext = createContext<CaseContextValue | null>(null)

export const CaseContextProvider = CaseContext.Provider

export function useCaseContext(): CaseContextValue {
  const value = useContext(CaseContext)
  if (!value) throw new Error('useCaseContext must be used inside CaseLayout')
  return value
}
